// extracted by mini-css-extract-plugin
export var icon = "_qa-0";